export default __webpack_public_path__ + "static/site-image-bf3b414a0d2659b9bb81c22b8285ff38.jpg";